export const SET_AUTH = "SET_AUTH";
export const GET_AUTH = "GET_AUTH";

export const SET_AUTH_HASOFFERS = "SET_AUTH_HASOFFERS";
export const RESET_AUTH_HASOFFERS = "RESET_AUTH_HASOFFERS";

export const LOG_OUT = "LOG_OUT";
